<div class="relative flex w-[480px] flex-col items-center gap-4 rounded-[20px] bg-background-white p-6">
  <section>
    <div class="mb-5 flex justify-center">
      <div class="border-1 rounded-full border border-dashed border-states-orange p-[1px]">
        <div class="flex aspect-square h-9 w-9 items-center justify-center rounded-full bg-states-orange/20">
          <svg-icon key="px-24-warning-2-1" class="text-states-orange" size="sm"></svg-icon>
        </div>
      </div>
    </div>

    <section class="flex flex-col gap-5 text-center">
      <h4 class="typo-h4-medium">
        {{
          (sameDayInProgress ? 'perio_exam_same_day_in_progress_dialog_title' : 'perio_exam_same_day_confirmation_dialog_title') | translate
        }}
      </h4>

      <h5 class="typo-h5-book whitespace-pre-line text-text-secondary">
        {{
          (sameDayInProgress ? 'perio_exam_same_day_in_progress_dialog_content' : 'perio_exam_same_day_confirmation_dialog_content')
            | translate
        }}
      </h5>
    </section>
  </section>

  <section class="mt-4 flex w-full gap-4">
    @if (!sameDayInProgress) {
      <button class="btn-secondary flex-1 justify-center" (click)="onCancelClick()">
        {{ 'perio_exam_same_day_confirmation_dialog_cancel_button' | translate }}
      </button>
      <button class="btn-primary flex-1 justify-center" (click)="onEditClick()">
        {{ 'perio_exam_same_day_confirmation_dialog_edit_button' | translate }}
      </button>
    } @else {
      <button class="btn-primary-big flex-1 justify-center" (click)="onCancelClick()">
        {{ 'perio_exam_same_day_in_progress_dialog_confirm_button' | translate }}
      </button>
    }
  </section>
</div>
